import React, { lazy } from 'react'

const LazyVideo = lazy(() => import(/* webpackChunkName: "desktopVideos" */ './videos'))
export const VideosRoute = () => <LazyVideo />

const LazyVideoDetail = lazy(() => import(/* webpackChunkName: "desktopVideoDetail" */ './video-detail'))
export const VideoDetailRoute = () => <LazyVideoDetail />

export default VideosRoute
